/**
 * Force trailing slashes to prevent breaking relativized paths
 */
export default function normalizePath(path = ''): string {
  if (path.startsWith('#')) return path
  return path.replace(/\/*([#?].*){0,1}$/, '/$1')
}
